import axiosInstance, { API_ROUTES } from '../lib/http/httpRequest';
import { AxiosResponse } from 'axios';
import { DismissBannerPayload, GetAllBannersForMemberResponse } from '@/state/banners/bannersTypes';

export const getAllBannersForMember = (): Promise<AxiosResponse<GetAllBannersForMemberResponse>> =>
    axiosInstance.get(`${API_ROUTES.BANNERS}`);

export const dismissBanner = (id: DismissBannerPayload): Promise<AxiosResponse<void>> =>
    axiosInstance.put(`${API_ROUTES.BANNERS}/${id}`);
